import { useEffect, useMemo, useState } from 'react';
import '../../../../styles.scss';
import { SettingOutlined } from '@ant-design/icons';

import { ConfigProvider, Pagination } from 'antd';
import { AgGridReact } from 'ag-grid-react';
import viVN from "antd/locale/vi_VN";
import { formatNumber } from '../../../../../../services/mixin';
import { NodataTable } from '../../../../../../components/NoDataTable';
import { FlattenedField } from '../../../../../CustomersV2/indexV2';
import { ICustomer } from '../../../../../../api/Customer_V2/customerApi_V2';
import { IPagination } from '../../../../../Customers/CustomerGroup/Component/AddGroup/AddNewGroup';
import { generateColumnsFromCodesAgGridReactRecordCar } from '../../../ServiceRecords/ContactInformation';
import { ColumnKey } from '../../../../../Customers/Tabs/CarListCardClone';
import { CustomLoadingOverlayTable, dataPagination, getWidthFromHeaderV2, renderValueAsJSX } from '../../../../../../until';
import { ICustomerFields } from '../../../../../../api/salesSericeCustomer/salesSericeCustomerApi';
import { ColDef } from 'ag-grid-community';
import { NO_VIEW } from '../../../../../../services/data';

interface Props {
  loadingTableDetail: boolean
  dataFieldsActive: FlattenedField[]
  data: ICustomer[]
  pagination: IPagination

  onPaginationChange: (page: number, pageSize: number) => void
}
const TabVehicleInvoiceTabDetail: React.FC<Props> = ({
  loadingTableDetail, dataFieldsActive, data, pagination,
  onPaginationChange
}) => {
  const [columnsMapShow, setColumnsMapShow] = useState<ColumnKey[]>([]);

  //#region Cấu hình cột
  const memoizedColumnDefs = useMemo(() => {
    return generateColumnsFromCodesAgGridReactRecordCar(
      columnsMapShow, dataFieldsActive, undefined,
      () => { }
    );
  }, [columnsMapShow, dataFieldsActive]);

  const tableData = useMemo(() => {
    return data.map((item) => {
      const fieldValues = item.fields.reduce((acc: Record<string, any>, field) => {
        acc[field.fieldCode] = field.view === false ? NO_VIEW : field.value;
        return acc;
      }, {});

      return {
        ...item,
        key: item.id.toString(),
        ...fieldValues
      };
    });
  }, [data]);

  useEffect(() => {
    const codes = dataFieldsActive.map((f) => f.fieldCode);
    setColumnsMapShow(codes);
  }, [dataFieldsActive]);
  //#endregion

  return (
    <>
      <div className="custom-page-css w-full flex flex-col items-center justify-between  pt-3">
        <div className="custom-page-css w-full flex flex-col items-center justify-between gap-3 pt-3">
          <div className="ag-theme-alpine custom-table-ag custom-css-table"

            style={{ width: '100%', height: tableData.length === 0 ? 250 : tableData.length < 10 ? tableData.length * 65 + 65 : 650 }}
          >
            <AgGridReact
              className="my-auto-height-grid"
              getRowStyle={(params: any) => ({
                backgroundColor: params?.rowIndex % 2 ? '#f7f9fc' : '#ffffff',
              })}
              rowData={tableData}
              columnDefs={memoizedColumnDefs}
              rowHeight={55}
              overlayNoRowsTemplate={NodataTable}
              onGridReady={(params) => {
                params.api.sizeColumnsToFit();
              }}

              loading={loadingTableDetail}
              loadingOverlayComponent={CustomLoadingOverlayTable}
              rowSelection="single"
              suppressRowClickSelection={true}
              onRowClicked={(params) => {
                const selected = params.node.isSelected();
                params.node.setSelected(!selected);
              }}
              // onSelectionChanged={(params) => setSelectId(params.api.getSelectedRows()[0]?.id)}

              // Performance optimizations
              suppressColumnVirtualisation={true} // Giữ tất cả columns trong DOM
              suppressRowVirtualisation={false} // Giữ row virtualization
              enableCellTextSelection={true}
              ensureDomOrder={true}
              debounceVerticalScrollbar={true}
              suppressScrollOnNewData={true}
              suppressDragLeaveHidesColumns={true}

              // Thêm các props sau để cải thiện scroll
              rowBuffer={20}
              maxBlocksInCache={10}
              infiniteInitialRowCount={1000}
            />
          </div>
          <ConfigProvider
            locale={viVN}
          >
            <div className="pagination-block">
              <Pagination
                showSizeChanger
                current={pagination.current}
                pageSize={pagination.pageSize}
                total={pagination.total}
                itemRender={(page, type, originalElement) => {
                  // Chỉ custom khi là nút số trang
                  if (type === 'page') {
                    return <span>{formatNumber(page)}</span>;
                  }
                  // prev / next / jump-prev / jump-next giữ nguyên
                  return originalElement;
                }}
                showTotal={() =>
                  `Tổng cộng ${dataPagination(
                    pagination.total,
                    pagination.pageSize,
                    pagination.current
                  ).totalPage} trang`
                }
                className="rs-pagination"
                onChange={onPaginationChange}
              />
            </div>
          </ConfigProvider>

        </div>
      </div>
    </>
  )
}

export default TabVehicleInvoiceTabDetail
